<template>
    <div id="riskWarningReport">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <div class="content">
                    <div class="contentTitle">风险预警报告</div>
                    <div class="contentVal">
                        <span>对企业业务的风险因素进行预警输出报告</span>
                        <span>让企业避免不必要的合作风险因素而增加成本</span>
                    </div>
                    <button class="btn" @click="showAlertFlag=true">立即咨询</button>
                </div>
            </div>
        </div>
        <!--相关产品-->
        <div class="relevantProduct">
            <div class="relevantProductTitle">相关产品</div>
            <!--产品列表-->
            <div class="relevantProductListWrap">
                <!--@click="toPage('/InformationCheck')"-->
                <div class="relevantProductList" style="margin-right: 128px;opacity: 0.3;cursor: not-allowed">
                    <img src="../../assets/img/bigIcon/信息核验.png"/>
                    <span>信息核验</span>
                </div>
                <div class="relevantProductList" @click="toPage('/znyxSystem')" style="margin-right: 128px;">
                    <img src="../../assets/img/bigIcon/智能营销系统.png"/>
                    <span>智能营销系统</span>
                </div>
                <div class="relevantProductList" @click="toPage('/modelFactory')" style="margin-right: 144px;">
                    <img src="../../assets/img/bigIcon/模型工厂.png"/>
                    <span>模型工厂</span>
                </div>
                <div class="relevantProductList" @click="toPage('/smartLabel')" style="margin-right: 128px;">
                    <img src="../../assets/img/bigIcon/智能标签.png"/>
                    <span>智能标签</span>
                </div>
                <!--@click="toPage('/RiskListFiltering')"-->
                <div class="relevantProductList" style="opacity: 0.3;cursor: not-allowed">
                    <img src="../../assets/img/bigIcon/风险名单过滤.png"/>
                    <span>风险名单过滤</span>
                </div>
            </div>
        </div>
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false"/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "riskWarningReport",
        data() {
            return {
                showAlertFlag: false
            }
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            toPage(page) {
                this.$router.push({path: page});
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("relevantProduct")[0], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #riskWarningReport {
        .bannerWrap {
            background: url("../../assets/img/ristWarning/风险预警报告banner.png") no-repeat center;
            background-color: #0E0B10;
        }

        .relevantProduct {
            width: 912px;
        }
    }
</style>
